import { MutableRefObject, DependencyList, useLayoutEffect } from 'react';

export const useIntersectionObserver = <T extends Element>(
    target: MutableRefObject<T>,
    callback: IntersectionObserverCallback,
    deps: DependencyList,
) => {
    useLayoutEffect(() => {
        const observer = new IntersectionObserver(callback);

        if (target.current) {
            observer.observe(target.current);
        }

        return () => {
            if (target.current) {
                observer.unobserve(target.current);
            }
        };
    }, deps);
};
